function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useState, forwardRef } from 'react';
import cn from 'classnames';
import { string, bool, func, shape, any } from 'prop-types';
import FormContext from '../../context/FormContext';
import FormGroupContext from '../../context/FormGroupContext';
/**
 * FormSwitch component.
 */

var FormSwitch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      rounded = _ref.rounded,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      on = _ref.on,
      off = _ref.off,
      fullWidth = _ref.fullWidth,
      transparent = _ref.transparent,
      defaultValue = _ref.defaultValue;

  var _useContext = useContext(FormGroupContext),
      inputId = _useContext.inputId;

  var _useContext2 = useContext(FormContext),
      inverted = _useContext2.inverted,
      onFormChange = _useContext2.onChange,
      defaultValues = _useContext2.defaultValues;

  var _useState = useState(defaultValue || (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues[name]) || on.value),
      _useState2 = _slicedToArray(_useState, 2),
      checkedValue = _useState2[0],
      setCheckedValue = _useState2[1];
  /**
   * Update the checked value before calling any given onChange handler.
   */


  var handleChange = function handleChange(evt) {
    var _evt$target = evt.target,
        checked = _evt$target.checked,
        value = _evt$target.value;

    if (checked) {
      setCheckedValue(value);
    }

    if (onChange) {
      onChange(evt);
    }

    if (onFormChange) {
      onFormChange(evt);
    }
  };

  return /*#__PURE__*/React.createElement("fieldset", {
    className: cn("form-switch d-flex p-relative", className, rounded && 'form-switch--rounded', inverted && 'form-switch--inverted', fullWidth && 'form-switch--full-width', transparent && 'form-switch--transparent'),
    ref: ref,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement("legend", {
    className: "sr-only"
  }, name), /*#__PURE__*/React.createElement("input", {
    className: "form-switch__input p-absolute",
    type: "radio",
    name: name,
    id: "".concat(inputId, "-on"),
    value: on.value,
    onClick: onClick,
    defaultChecked: checkedValue === on.value
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-switch__label p-relative flex-grow-1 text-center pa-sm ma-reset",
    htmlFor: "".concat(inputId, "-on"),
    id: "label-".concat(inputId, "-on")
  }, on.text), /*#__PURE__*/React.createElement("input", {
    className: "form-switch__input p-absolute",
    type: "radio",
    name: name,
    id: "".concat(inputId, "-off"),
    value: off.value,
    onClick: onClick,
    defaultChecked: checkedValue === off.value
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-switch__label p-relative flex-grow-1 text-center pa-sm ma-reset",
    htmlFor: "".concat(inputId, "-off"),
    id: "label-".concat(inputId, "-off")
  }, off.text), /*#__PURE__*/React.createElement("span", {
    className: cn("form-switch__selector full-height p-absolute", className, rounded && 'form-switch__selector--rounded')
  }));
});
FormSwitch.displayName = 'FormSwitch';
FormSwitch.defaultProps = {
  className: null,
  rounded: true,
  onChange: null,
  onClick: null,
  fullWidth: false,
  transparent: false,
  defaultValue: null
};
FormSwitch.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValue: any,
  className: string,
  name: string.isRequired,
  rounded: bool,
  onChange: func,
  onClick: func,
  fullWidth: bool,
  transparent: bool,
  on: shape({
    text: string,
    value: string
  }).isRequired,
  off: shape({
    text: string,
    value: string
  }).isRequired
} : {};
export default FormSwitch;